import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="pt-32 pb-64 lg:pt-48 lg:pb-96 px-4 lg:px-6 bg-no-repeat relative bg-cover hero-background"
      style={{
        backgroundImage: "url('https://customer-assets.emergentagent.com/job_cisto-i-fino/artifacts/xu941fli_c2544cb7-271e-4b60-89db-46b99e3b4b61.png')",
      }}
    >
      <style>{`
        .hero-background {
          background-size: cover;
          background-position: center 60%;
        }
        @media (max-width: 1023px) {
          .hero-background {
            background-position: 65% center;
          }
        }
      `}</style>
      <div className="absolute inset-0 bg-black/25 lg:bg-black/15"></div>
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex justify-center items-center">
          <div className="space-y-8 max-w-4xl text-center">
            <div className="inline-block px-4 py-2 bg-blue-100/90 rounded-full">
              <span className="text-blue-700 font-semibold text-sm">Profesionalne Usluge Čišćenja</span>
            </div>
            
            <h1 className="lg:text-6xl drop-shadow-lg !font-bold text-2xl sm:!text-3xl text-center !text-[#000000]">
              <span className="whitespace-nowrap">Besprekorno Čisti</span> Prostori, Svaki Put
            </h1>
            
            <p className="drop-shadow-md !font-semibold !text-2xl !text-[#000000]">
              Osetite razliku sa Cisto i Fino. Pružamo izuzetne usluge čišćenja za domove, kancelarije i komercijalne prostore sa pažnjom posvećenom svakom detalju.
            </p>

            <div className="space-y-3 flex flex-col items-center">
              <div className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <span className="drop-shadow-md !font-semibold !text-xl !text-[#000000]">Profesionalan i sertifikovan tim</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <span className="drop-shadow-md !font-semibold !text-xl !text-[#000000]">Ekološki prihvatljivi proizvodi</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <span className="drop-shadow-md !font-semibold !text-xl !text-[#000000]">100% garancija zadovoljstva</span>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 justify-center">
              <button
                onClick={scrollToContact}
                className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-all hover:scale-105 flex items-center gap-2 shadow-xl">

                Dobijte Besplatnu Ponudu
                <ArrowRight className="w-5 h-5" />
              </button>
              <button
                onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold border-2 border-white hover:bg-blue-50 transition-all shadow-xl">

                Naše Usluge
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default Hero;